import { render, staticRenderFns } from "./templateCkeditor.vue?vue&type=template&id=0ae8a0ce&scoped=true"
import script from "./templateCkeditor.vue?vue&type=script&lang=js"
export * from "./templateCkeditor.vue?vue&type=script&lang=js"
import style0 from "./templateCkeditor.vue?vue&type=style&index=0&id=0ae8a0ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae8a0ce",
  null
  
)

export default component.exports